import React, { useState } from 'react';
import { requestPasswordReset } from '../../../auth/password-reset/passwordResetApi';
import GradientButton from '../../../components/buttons/GradientButton';
import NeatScheduleMark from '../brand/NeatScheduleMark';
import './forgot-password.css';

const UnifiedForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      await requestPasswordReset({ email: email.trim() });
      setSuccess(true);
      setEmail('');
    } catch (err) {
      const message = err?.message || err?.details || 'Failed to send reset link. Please try again.';
      setError(message);
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    window.close();
  };

  return (
    <div className="forgot-password-container">
      <div className="forgot-password-inner">
        <div className="forgot-password-logo-wrap">
          <NeatScheduleMark className="forgot-password-logo" />
        </div>

        <div className="forgot-password-card">
        <div className="forgot-password-header">
          <h1 className="forgot-password-title">Forgot password?</h1>
          <p className="forgot-password-subtitle">
            Enter the email you use to sign in and we&apos;ll send you a link to reset your password.
          </p>
        </div>

        <form className="forgot-password-form" onSubmit={handleSubmit} noValidate>
          {error && (
            <div
              id="forgot-email-error"
              className="forgot-password-alert forgot-password-alert-error"
              role="alert"
              aria-live="polite"
            >
              <span className="forgot-password-alert-icon" aria-hidden>!</span>
              <span>{error}</span>
            </div>
          )}

          {success && (
            <div
              className="forgot-password-alert forgot-password-alert-success"
              role="status"
              aria-live="polite"
            >
              <span className="forgot-password-alert-icon forgot-password-alert-icon-success" aria-hidden>✓</span>
              <div className="forgot-password-success-content">
                <strong>Check your email</strong>
                <p>We sent a reset link to your email. Click the link to set a new password. If you don&apos;t see it, check your spam folder.</p>
              </div>
            </div>
          )}

          {!success && (
            <>
              <div className="forgot-password-field">
                <label htmlFor="forgot-email" className="forgot-password-label">
                  Email address
                </label>
                <div className="forgot-password-input-wrap">
                  <span className="forgot-password-input-icon" aria-hidden>
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" /><polyline points="22,6 12,13 2,6" /></svg>
                  </span>
                  <input
                    type="email"
                    id="forgot-email"
                    className="forgot-password-input"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="you@example.com"
                    required
                    disabled={loading}
                    autoComplete="email"
                    autoFocus
                    aria-invalid={!!error}
                    aria-describedby={error ? 'forgot-email-error' : 'forgot-email-helper'}
                  />
                </div>
                <span id="forgot-email-helper" className="forgot-password-helper">
                  We&apos;ll send the reset link to this address
                </span>
              </div>

              <GradientButton
                type="submit"
                fullWidth
                disabled={loading}
                className="forgot-password-btn-primary"
                aria-busy={loading}
              >
                {loading ? (
                  <>
                    <span className="forgot-password-spinner" aria-hidden />
                    Sending...
                  </>
                ) : (
                  'Send reset link'
                )}
              </GradientButton>
            </>
          )}

          {success && (
            <div className="forgot-password-success-actions">
              <GradientButton
                type="button"
                fullWidth
                className="forgot-password-btn-primary"
                onClick={() => (window.location.href = '/app/login')}
              >
                Back to sign in
              </GradientButton>
              <button
                type="button"
                className="forgot-password-btn-secondary"
                onClick={handleClose}
              >
                Close window
              </button>
            </div>
          )}
        </form>
        </div>
      </div>
    </div>
  );
};

export default UnifiedForgotPassword;
